import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const ProjectWorkloadChart = ({ projects = [] }) => {
  // Convert API response into chart data
  const projectData = projects
    .map((project) => ({
      project:
        project.project_name ||
        project.projectName ||
        "Unnamed Project",

      hours: Number(
        project.estimated_hours ??
        project.estimatedHours ??
        0
      ),
    }))
    .filter((project) => project.hours > 0);

  // Get top 5 projects by estimated workload
  const topProjects = [...projectData]
    .sort((a, b) => b.hours - a.hours)
    .slice(0, 5);

  // Empty state
  if (topProjects.length === 0) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">

        <div className="mb-3">
          <h2 className="text-lg font-semibold text-gray-800">
            Top 5 Projects by Estimated Workload
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Projects with the highest estimated hours
          </p>
        </div>

        <div className="flex h-[240px] items-center justify-center">
          <p className="text-sm text-slate-400">
            No workload data available.
          </p>
        </div>

      </div>
    );
  }

  // Find highest workload
  const maxHours = Math.max(
    ...topProjects.map(
      (project) => project.hours
    )
  );

  // Create a suitable Y-axis maximum
  const yAxisMax =
    Math.ceil(maxHours / 100) * 100 || 100;

  // Create Y-axis ticks
  const tickCount = 5;

  const tickStep = Math.ceil(
    yAxisMax / tickCount / 100
  ) * 100;

  const finalMax = Math.max(
    tickStep * tickCount,
    yAxisMax
  );

  const ticks = Array.from(
    { length: tickCount + 1 },
    (_, index) => index * tickStep
  );

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">

      {/* Header */}

      <div className="mb-3">

        <h2 className="text-lg font-semibold text-gray-800">
          Top 5 Projects by Estimated Workload
        </h2>

        <p className="mt-1 text-sm text-gray-500">
          Projects with the highest estimated hours
        </p>

      </div>

      {/* Chart */}

      <div
        style={{
          width: "100%",
          height: "240px",
          minHeight: "240px",
        }}
      >

        <ResponsiveContainer
          width="100%"
          height="100%"
        >

          <BarChart
            data={topProjects}
            margin={{
              top: 5,
              right: 20,
              left: 5,
              bottom: 5,
            }}
            barCategoryGap="10%"
          >

            {/* Grid */}

            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
            />

            {/* Project names hidden */}

            <XAxis
              dataKey="project"
              tick={false}
              axisLine={false}
              tickLine={false}
            />

            {/* Y Axis */}

            <YAxis
              domain={[
                0,
                finalMax,
              ]}
              ticks={ticks}
              axisLine={false}
              tickLine={false}
              tick={{
                fontSize: 10,
                fill: "#6B7280",
              }}
            />

            {/* Tooltip */}

            <Tooltip
              cursor={{
                fill: "transparent",
              }}
              formatter={(value) => [
                `${Number(value).toLocaleString()} hours`,
                "Estimated Workload",
              ]}
              labelFormatter={(label) =>
                `Project: ${label}`
              }
            />

            {/* Bars */}

            <Bar
              dataKey="hours"
              fill="#2563EB"
              radius={[
                5,
                5,
                0,
                0,
              ]}
              barSize={22}
            />

          </BarChart>

        </ResponsiveContainer>

      </div>

    </div>
  );
};

export default ProjectWorkloadChart;